import { render, staticRenderFns } from "./C-2-2-2-1__SubCategory_DialogCustomized-Filter-Create.vue?vue&type=template&id=7697349b&"
import script from "./C-2-2-2-1__SubCategory_DialogCustomized-Filter-Create.vue?vue&type=script&lang=js&"
export * from "./C-2-2-2-1__SubCategory_DialogCustomized-Filter-Create.vue?vue&type=script&lang=js&"
import style0 from "./C-2-2-2-1__SubCategory_DialogCustomized-Filter-Create.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VCombobox,VForm,VTextField})
